import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect } from "react";
import PrintIcon from "@material-ui/icons/Print";
import { FormatoImpresionReclamo } from "./FormatoImpresionReclamo";
import { useState } from "react";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { TraerReclamoPorId } from "../../../../actions/reclamos/reclamosActions";

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundColor: theme.palette.grey[50],
  },
  title: {
    color: theme.palette.primary.main,
  },
}));

export const ImpresionReclamo = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { reclamoTomado, items } = useSelector((state) => state.reclamos);
  const { reclamoImp, titulo } = props;

  useEffect(() => {
    if (titulo) {
      dispatch(TraerReclamoPorId(reclamoTomado?.id));
    }
  }, [titulo, reclamoTomado.id]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const handlePrintRow = () => {
    handlePrint();
    setOpen(false);
  };

  return (
    <>
      {titulo ? (
        <>
          <Grid item xs={12} style={{ textAlign: "center", margin: ".5em" }}>
            <Typography align="center" variant="h5" color="secondary">
              <span>
                ID CASO:{" "}
                <span className={classes.title}>{reclamoTomado.id}</span>
              </span>
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center", margin: ".5em" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickOpen}
            >
              IMPRIMIR COMPROBANTE
            </Button>
          </Grid>
        </>
      ) : (
        <Button onClick={handleClickOpen}>
          <PrintIcon fontSize="large" />
        </Button>
      )}
      {titulo ? (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
          <DialogContent className={classes.background}>
            <FormatoImpresionReclamo
              //reclamo={reclamoTomado}
              reclamo={items}
              handleClose={handleClose}
              handlePrintRow={handlePrintRow}
              componentRef={componentRef}
              impresionIngreso={true}
              modal
            />
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
          <DialogContent className={classes.background}>
            <FormatoImpresionReclamo
              //reclamo={reclamoTomado}
              reclamo={reclamoImp}
              handleClose={handleClose}
              handlePrintRow={handlePrintRow}
              componentRef={componentRef}
              impresionIngreso={false}
              modal
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
